import { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import useScreenSize from "hoc/useScreenSize";
import { RootState } from "interfaces/generics.type";
import ChangeVehicleButton from "modules/fitment/change-select-vehicle/ChangeVehicleButton";
import { useSelector } from "react-redux";
import { getModelIconUrl } from "util/helper/getModelIconUrl";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import styles from "./categoryVehicleBannerSection.module.scss";

function B2BCategoryVehicleBanner() {
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const [isMobile] = useScreenSize();
  const vehicleDes = createVehicleDescription(selectedVehicle, true);

  return (
    <div className={styles.b2b_category_vehicle}>
      <PAImage
        src={getModelIconUrl({ make: selectedVehicle?.make, model: selectedVehicle.model, year: selectedVehicle.year })}
        width={isMobile ? 150 : 180}
        height={isMobile ? 60 : 80}
        fallBackImage={createMakeImageSource(selectedVehicle)}
      />
      <div className={styles.b2b_vehicle_text}>
        <PAText bold>
          {vehicleDes}
        </PAText>
        <ChangeVehicleButton
          className={styles.b2b_change_vehicle}
          defaultButtonType={BUTTON_TYPE.OUTLINE}
        />
      </div>
    </div>
  );
}

export default B2BCategoryVehicleBanner;
